<template>
   <el-dialog title="交集" :visible.sync="viewVisible" :close-on-click-modal="false" @close="close" width="548px">
    <template slot="title" >
      <span>交集</span>
    </template>
    <div v-if="!connect" class="tip-box">
      <img
        src="@/assets/images/new_icon_waring_yellow.png"
        class="tip-box-icon"
      />
      <span style="margin-left: 24px; color: #333">未连接人群数据源</span>
    </div>
    <el-form :model="intersectionForm" :rules="rules" ref="ruleForm" :disabled="isReadOnly" :label-width="formLabelWidth">
      <el-form-item label="节点名称" prop="name" style="position: relative;">
        <div class="name-wrap">
          <el-input class="name-wrap-input" v-model="intersectionForm.name" autocomplete="off" :maxlength="50" show-word-limit></el-input>
          <div class="name-wrap-setName" @click="setName">智能命名</div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" :disabled="isReadOnly" @click="intersectionSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: 'intersectionDialog',
  data() { 
    return {
      connect:true,
      formLabelWidth: 'auto',
      rules: {
        name: [
          { required: true, message: '请输入节点名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ]
      },
      intersectionForm: {
        name: ''
      }
    }
  },
  computed: {
    viewVisible: {
      get: function () {
        return this.visible
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    getNameLength: function () {
      return this.intersectionForm.name.length
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    nodeId: Number,
    marketingId: Number,
    'isReadOnly': {
      type: Boolean,
      default: false
    }
  },
  components:{
  },
  created() {
    //双击打开的时候显示节点名称
    mnode.getNode({nodeId: this.nodeId}).then(res => {
      if (res.code === 1 && res.data.name) {
        this.connect = res.data.isHaveParent; 
        this.intersectionForm.name = res.data.name
      }
    })
  },
  methods:{
    // 智能命名
    setName(){
      mnode.getAutoName(this.nodeId).then(res=>{
        console.log(res);
        if(res.code == 1){
          this.intersectionForm.name = res.data
        }else{
          this.$message.warning(res.message)
        }
      })
    },
     intersectionSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify()
          mnode.updateDetail(data).then(res => {
            if (res.code === 1) {
              this.$message.success(res.message)
              this.viewVisible = false
              this.$emit('change-name', data)
            }
          })
        } else {
          return false
        }
      })
    },
    getDataify () {
      let formData = {}
      formData.nodeId = this.$props.nodeId
      formData.name = this.intersectionForm.name
      return formData
    },
    close () {
      this.viewVisible = false
    }
  },
 }
</script>

<style lang="scss" scoped>
.name-wrap{
  display: flex;
  align-items: center;
  &-input{
    width: 320px;
    /deep/.el-input__inner{
      padding-right: 50px!important;
    }
  }
  &-setName{
    color: #7f85e9;
    cursor: pointer;
    margin-left: 8px;
  }
}

.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-bottom: 16px;
  color: #999999;
  background: #fffaee;
  position: relative;
  line-height: 42px;

  &-icon{
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 14px 4px 0 3px;
  }
}
</style>